import { HeadersWithoutApiKeyWorkaround } from './constants';
import deleteClassType from '../graphql/mutations/deleteClassType';
import queryClusterSets from '../graphql/queries/queryClusterSets';
import createClassType from '../graphql/mutations/createClassType';
import queryCampaignPosts from '~/graphql/queries/queryCampaignPosts';
import queryIdentifyClasses from '~/graphql/queries/queryIdentifyClasses';

export const state = () => ({});

export const actions = {
    async createClassType(context, payload) {
        return (
            await this.app.apolloProvider.defaultClient.mutate({
                mutation: createClassType.createClassTypeMutation,
                context: HeadersWithoutApiKeyWorkaround,
                variables: {
                    ...payload,
                },
            })
        ).data.createClassType;
    },

    async fetchClusterSets(context, payload) {
        return (
            await this.app.apolloProvider.defaultClient.query({
                query: queryClusterSets.clusterSets,
                context: HeadersWithoutApiKeyWorkaround,
                variables: { campaignID: payload.campaignID, includeIDs: payload.includeIDs || false },
            })
        ).data.clusterSets.clusterSets;
    },

    async deleteClassType(context, payload) {
        await this.app.apolloProvider.defaultClient.mutate({
            mutation: deleteClassType.deleteClassTypeMutation,
            context: HeadersWithoutApiKeyWorkaround,
            variables: {
                ...payload,
            },
        });
    },

    async identifyHazards(context, { posts }) {
        const setID = 'hazards';
        const postIDs = posts.map((post) => post.id);
        const identifiedHazards = await this.app.apolloProvider.defaultClient.query({
            query: queryIdentifyClasses.identifyClasses,
            variables: { setID, postIDs },
            context: HeadersWithoutApiKeyWorkaround,
        });
        return identifiedHazards.data.identifyClasses.identified;
    },
};

export const mutations = {};

export const getters = {};
